<div class="avatar-box">
    <span class="avatar profile"><ion-skeleton-text animated></ion-skeleton-text></span>
    <div class="avatar-text">
        <p><ion-skeleton-text animated style="width: 30%"></ion-skeleton-text></p>
        <p><ion-skeleton-text animated style="width: 20%"></ion-skeleton-text></p>
        <p><ion-skeleton-text animated style="width: 30%"></ion-skeleton-text></p>
    </div>
</div>
